import {PolicyDocData} from './PolicyDocData'
import {Company} from '../Company'

export class MemberPolicyDocData extends PolicyDocData {
    company: Company
}
